import React from "react";
import PropTypes from "prop-types";

const SettingsCard = props => {
	const { id, sectionRef, title, subtitle, children } = props;
	return (
		<div
			id={id}
			className="panel panel-default"
		>
			<div
				className="panel-heading"
				ref={sectionRef}
			>
				<h3 className="panel-title">{title}</h3>
				<small className="text-muted">{subtitle}</small>
			</div>
			<div className="panel-body container-fluid">{children}</div>
		</div>
	);
};

SettingsCard.propTypes = {
	id: PropTypes.string.isRequired,
	sectionRef: PropTypes.any.isRequired,
	title: PropTypes.string.isRequired,
	subtitle: PropTypes.string,
	children: PropTypes.any.isRequired,
};

SettingsCard.defaultProps = {
	subtitle: "",
};

export default SettingsCard;
